import { createContext, useContext } from 'react'

import type { AdditionalDataAPI } from '@twisto/api-cms/custom-types'

const AdditionalDataContext = createContext<AdditionalDataAPI | null>(null)

export const AdditionalDataProvider = ({
  additionalData,
  children,
}: {
  additionalData: AdditionalDataAPI
  children: React.ReactNode
}) => (
  <AdditionalDataContext.Provider value={additionalData}>
    {children}
  </AdditionalDataContext.Provider>
)

export const useAdditionalData = () => {
  const context = useContext(AdditionalDataContext)
  if (!context) {
    throw new Error(
      'useAdditionalData must be used within an AdditionalDataProvider'
    )
  }

  return context
}
